import { NSAHomePage, NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { NWSVolumeLayout } from "../NWSVolumeLayout";
import { NWSVolumeRouterProps } from "../NWSVolumeRouterProps";

interface HomePageProps extends NSARouterMakerResult, NWSVolumeRouterProps { }

class HomePage extends Component<HomePageProps>
{
    override render()
    {
        return (
            <NWSVolumeLayout {...this.props}>
                <NSAHomePage {...this.props} />
            </NWSVolumeLayout>
        );
    }
}

export default HomePage;